import React, { memo } from "react"
import { Flex, Text } from "@chakra-ui/react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import "swiper/css/navigation"

import { GiftWithPurchaseProduct } from "@app/components/Cart/GiftWithPurchase/GiftWithPurchaseProduct"
import CarouselButton from "@app/components/CarouselButton"

import "swiper/css"

type Props = {
  products: any[]
  title: string
  isAboveMinimumSpend: boolean
}

export const GiftWithPurchaseSwiper: React.FC<Props> = memo(({ products, title, isAboveMinimumSpend }) => (
  <>
    <Flex direction="row" justifyContent="space-between" mb={5} mt={2}>
      <Text size="smTight">{title}</Text>
      {products.length > 1 && (
        <Flex
          gap={{ base: 12, md: 13 }}
          position="relative"
          alignItems="center"
          sx={{
            ".gwp-swiper-button-next::after, .gwp-swiper-button-prev::after": {
              content: '""',
            },
            ".gwp-swiper-button-prev.swiper-disabled, .gwp-swiper-button-next.swiper-disabled": {
              opacity: 0.3,
              pointerEvents: "none",
            },
          }}
        >
          <CarouselButton
            className="gwp-swiper-button-prev"
            direction="prev"
            icon="carouselChevronPair"
            label="Previous gift"
            variant="onlyIcon"
          />

          <CarouselButton
            className="gwp-swiper-button-next"
            direction="next"
            icon="carouselChevronPair"
            label="Next gift"
            variant="onlyIcon"
          />
        </Flex>
      )}
    </Flex>

    <Swiper
      modules={[Navigation]}
      slidesPerView={products.length > 1 ? 1.1 : 1}
      spaceBetween={8}
      breakpoints={{ 768: { spaceBetween: 12 } }}
      simulateTouch={false}
      pagination={{ clickable: true }}
      navigation={{
        nextEl: ".gwp-swiper-button-next",
        prevEl: ".gwp-swiper-button-prev",
        disabledClass: "swiper-disabled",
      }}
    >
      {products.map((p: any, i: number) => (
        <SwiperSlide key={`gwp-product-${i}`} style={{ alignSelf: "center" }}>
          <GiftWithPurchaseProduct product={p} isDisabled={!isAboveMinimumSpend} />
        </SwiperSlide>
      ))}
    </Swiper>
  </>
))
